















































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import Character, { CharacterShortData } from '@/classes/character/character.ts';
import { Talents, TalentField } from '@/classes/character/allValues.ts';
import Talent from '@/classes/attributes/talent.ts';
import TalentCollection from '@/classes/attributes/talentCollection.ts';
import TalentFieldObject from '@/classes/attributes/talentFieldObject.ts';
import CheckDialog from './check.vue';
import CreateCharacter from './createCharacter.vue';
import ClassCardSelectionDialog from './classCardSelectionDialog.vue';
import SingleCharacterShort from './singleCharacterShort.vue';
import ClassCard from './classCard.vue';
import { User } from '../../interfaces/User';
import { CharacterClasses } from '../../classes/character/classes';
import { ClassCardData, UpdateCharacterClassCardsPayload } from '../../interfaces/character/classCard';
import players from '../../constants/players';
import { ValueExport } from '../../classes/attributes/valueAttribute';
import FirebaseRealtime from '@/classes/firebaseRealtime';

@Component({
  components: {
    CheckDialog,
    CreateCharacter,
    ClassCard,
    SingleCharacterShort,
  },
})
export default class CharacterList extends Vue {
  @Prop()
  public characterId!: string;

  private talentCollection: TalentCollection = new TalentCollection();
  private loading: boolean = true;

  private focusCharacterId: string | null = null;
  private checkDialog = false;
  private createDialog = false;
  private selectedCharacter: CharacterShortData | null = null;
  private loadedClassCards: string[] = [];
  private classCardsOfCharacters: { [characterId: string]: string[] } = {};
  private fab = false;
  private extendedView = false;
  private showCurrentValues = false;
  private showClasscards = false;

  private viewSaving = false;

  public created() {
    this.$store.dispatch('loadGroup').then(() => {
      this.$store.dispatch('watchCharacters');
      this.loading = false;
    });
  }

  public beforeDestroy() {
    FirebaseRealtime.clearListeners();
  }

  public onCheckDialogClick(characterId) {
    this.focusCharacterId = characterId;
    this.checkDialog = true;
  }

  private onCreateCharacterClick() {
    this.focusCharacterId = null;
    this.createDialog = true;
  }

  private onCharacterCreated() {
    this.createDialog = false;
    this.loading = true;
    let counter = 4;
    // Give functions some time to process
    const interval = setInterval(() => {
      this.$store.dispatch('loadGroup').then(() => {
        this.loading = false;
      });
      if (counter <= 0) {
        clearInterval(interval);
      } else {
        counter--;
      }
    }, 1500);
  }

  get characterShorts(): CharacterShortData[] {
    return this.$store.getters.characterShorts;
  }

  get focusName() {
    const focusCharacter = this.characterShorts.find(
      (characterShort) => characterShort.characterId === this.focusCharacterId,
    );
    if (focusCharacter) {
      return focusCharacter.name;
    } else {
      return null;
    }
  }

  private characterClassCardsLoading(character: Character) {
    return !(character.class === null || this.loadedClassCards.includes(character.class));
  }

  private getClassCardsByCharacter(character: CharacterShortData): ClassCardData[] {
    if (character.class === null || typeof this.classCardsOfCharacters[character.characterId] === 'undefined') {
      return [];
    }

    const classCards: ClassCardData[] = this.$store.getters.classCardsByClass(character.class);
    return classCards.filter((card) =>
      this.classCardsOfCharacters[character.characterId].includes(card.id ? card.id : ''),
    );
  }

  private onSettingsChange() {
    this.viewSaving = true;
    const payload = {
      component: 'characterList',
    };
    this.$store.dispatch('updateViewSettings').then(() => {
      this.viewSaving = false;
    });
  }
}
